<script>
import { mapGetters } from 'vuex';
import { useRouter } from 'vue-router';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { useAlert } from 'dashboard/composables';

import PageHeader from 'dashboard/routes/dashboard/settings/SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  name: 'QuePasaChannelCreate',
  components: {
    PageHeader,
    NextButton,
  },
  setup() {
    return { router: useRouter(), v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: 'QuePasa',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    inboxName: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) return;

      try {
        const inbox = await this.$store.dispatch('inboxes/createChannel', {
          name: this.inboxName.trim(),
          channel: { type: 'quepasa_channel' },
        });

        this.router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            inbox_id: inbox.id,
          },
        });
      } catch (error) {
        useAlert(
          error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            this.$t('QUEPASA_CHANNEL.CREATE.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <div class="overflow-auto col-span-6 p-6 w-full h-full">
    <PageHeader
      :header-title="$t('QUEPASA_CHANNEL.CREATE.TITLE')"
      :header-content="$t('QUEPASA_CHANNEL.CREATE.DESC')"
    />

    <form
      class="flex flex-col gap-4 flex-wrap mx-0"
      @submit.prevent="createChannel"
    >
      <label :class="{ error: v$.inboxName.$error }">
        {{ $t('QUEPASA_CHANNEL.CREATE.INBOX_NAME.LABEL') }}
        <input
          v-model="inboxName"
          data-target="quepasa-channel-create-inbox-name"
          type="text"
          :placeholder="$t('QUEPASA_CHANNEL.CREATE.INBOX_NAME.PLACEHOLDER')"
          @blur="v$.inboxName.$touch"
        />
        <span v-if="v$.inboxName.$error" class="message">
          {{ $t('QUEPASA_CHANNEL.CREATE.INBOX_NAME.ERROR') }}
        </span>
      </label>

      <div>
        <NextButton
          :is-loading="uiFlags.isCreating"
          data-target="quepasa-channel-create-submit"
          type="submit"
          solid
          blue
          :label="$t('QUEPASA_CHANNEL.CREATE.SUBMIT')"
        />
      </div>
    </form>
  </div>
</template>
